export const blockIconsSocialWaterDrop = (
	<span className='material-symbols-outlined'>water_drop</span>
);
